import React, { useMemo } from 'react';
import type { DataTableRenderCellParams, DataTableRowEventHandler } from '@/components/custom/erp/data-table-v2';
import type { ButtonType } from '@/components/custom/erp/input-table-v2';
import { EditableTableWithContext } from '../EditableTableWithContext';
import { SelectedCellInfo } from '../hooks/useDetailRows';
import { getFeeTableColumns } from './columns';
import { FormMode } from '@/types/form';

interface FeeDetailTabProps {
  formMode: FormMode;
  rows: { uuid?: string | null }[];
  selectedRowUuid?: string | null;
  selectedCell?: SelectedCellInfo | null;
  onRowClick?: DataTableRowEventHandler<MuaHangRecord>;
  onCellClick?: (params: DataTableRenderCellParams<MuaHangRecord>) => void;
  onMoveRow: (direction: 'up' | 'down') => void;
  onCellValueChange: (rowUuid: string, field: string, newValue: MuaHangRecord) => void;
}

const FEE_DETAIL_ACTION_ORDER: ButtonType[] = ['moveUp', 'moveDown', 'export', 'pin'];
const noop = () => {};

export const FeeDetailTab: React.FC<FeeDetailTabProps> = ({
  formMode,
  rows,
  selectedRowUuid,
  selectedCell,
  onRowClick,
  onCellClick,
  onMoveRow,
  onCellValueChange
}) => {
  const columns = useMemo(() => getFeeTableColumns(onCellValueChange), [onCellValueChange]);
  const tableActions = useMemo(
    () => ({
      moveUp: () => onMoveRow('up'),
      moveDown: () => onMoveRow('down'),
      export: noop,
      pin: noop
    }),
    [onMoveRow]
  );

  return (
    <EditableTableWithContext
      formMode={formMode}
      rows={rows}
      onRowClick={onRowClick}
      onCellClick={onCellClick}
      selectedRowId={selectedRowUuid || undefined}
      selectedCell={selectedCell}
      columns={columns}
      actions={tableActions}
      actionOrder={FEE_DETAIL_ACTION_ORDER}
    />
  );
};

export default FeeDetailTab;
